import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import Layout from "../layout/Layout";
import Banner from "../components/home/Banner";
import About from "../components/home/About";
import Services from "../components/home/Services";
import Homeservices from "../components/home/Homeservices";
// import Leads from "../components/home/Leads";
import Stats from "../components/home/Stats";
import Subscribe from "../components/home/Subscribe";
import Testimonials from "../components/home/Testimonials";
import Ourclients from "../components/home/Ourclients";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import { AuthContext } from "../context/AuthContext";

const Home = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard-view");
    }
  }, [isAuthenticated, navigate]);

  return (
    <>
      <Layout>
        <Banner />
        <IndustryLeaders />
        <About />
        {/* <Services /> */}
        {/* <Leads /> */}
        {/* <Homeservices /> */}
        {/* <Stats /> */}
        <Testimonials />
        {/* <Ourclients /> */}
        {/* <Subscribe /> */}
      </Layout>
    </>
  );
};

export default Home;
